<template>
  <div class="repair-photo-panel">
    <div v-if="allPhotoGroups.length === 0" class="empty-photos">暂无数据</div>

    <div v-for="group in allPhotoGroups" v-else :key="group.title" class="photo-group">
      <div class="photo-group-title">{{ group.title }}</div>
      <div class="photo-list">
        <el-image v-for="(item, index) in group.items" :key="`${group.title}-${index}`" class="repair-photo" :src="item.url" :preview-src-list="group.items.map(photo => photo.url)" fit="cover" @click="openFile(item)"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import { getRepairPhotos } from '@/api/work/repairDetailApi'

export default {
  name: 'RepairDetailPhotos',
  props: {
    repairId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      photos: [],
      beforePhotos: [],
      afterPhotos: []
    }
  },
  computed: {
    allPhotoGroups() {
      return [
        { title: this.$t('repairDetail.orderPhotos'), items: this.photos },
        { title: this.$t('repairDetail.beforeRepairPhotos'), items: this.beforePhotos },
        { title: this.$t('repairDetail.afterRepairPhotos'), items: this.afterPhotos }
      ].filter(group => group.items && group.items.length > 0)
    }
  },
  methods: {
    normalizePhotos(photos) {
      return (Array.isArray(photos) ? photos : [])
        .map(photo => {
          if (typeof photo === 'string') {
            return { url: photo }
          }
          return photo || {}
        })
        .filter(photo => typeof photo.url === 'string' && photo.url.trim())
    },
    async loadData() {
      try {
        const data = await getRepairPhotos(this.repairId)
        this.photos = this.normalizePhotos(data.photos)
        this.beforePhotos = this.normalizePhotos(data.beforePhotos)
        this.afterPhotos = this.normalizePhotos(data.afterPhotos)
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    openFile(item) {
      this.$emit('show-image', item)
    }
  }
}
</script>

<style scoped>
.repair-photo-panel { min-height: 150px; }
.photo-group { margin-bottom: 24px; }
.photo-group:last-child { margin-bottom: 0; }
.photo-group-title { margin-bottom: 12px; color: #1D2129; font: 500 14px/20px 'PingFang SC', sans-serif; }
.photo-list { display: flex; flex-wrap: wrap; gap: 16px; }
.repair-photo { width: 120px; height: 120px; border-radius: 8px; overflow: hidden; background: #F3F7FB; }
.empty-photos { height: 120px; display: flex; align-items: center; justify-content: center; color: #8C9BB4; font-size: 14px; }
</style>
